import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export const PaymentRoutes = ({
  path: 'register',
  getData: ({ context: { props } }) => props,
  async getComponent () {
    const {
      default: AccountContainer
    } = await import('./containers/AccountContainer.tsx')
      .catch(handleChunkLoadError);
    return AccountContainer;
  },
  children: [
    {
      path: '',
      async getComponent () {
        const {
          default: Payment
        } = await import('./routes/payment/components/Payment')
          .catch(handleChunkLoadError);
        return Payment;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'success',
      async getComponent () {
        const {
          default: PaymentSuccess
        } = await import('./routes/payment/components/PaymentSuccess')
          .catch(handleChunkLoadError);
        return PaymentSuccess;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'plan/:planCode',
      async getComponent () {
        const {
          default: Payment
        } = await import('./routes/payment/components/Payment')
          .catch(handleChunkLoadError);
        return Payment;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});

export default ({
  path: 'account',
  getData: ({ context: { props } }) => props,
  getComponent: async (nextState) => {
    const { default: AccountContainer } = await import(/* webpackChunkName: "account-container" */ './containers/AccountContainer.tsx')
      .catch(handleChunkLoadError);

    return AccountContainer;
  },
  children: [
    {
      path: '',
      getData: ({ context: { props } }) => props,
      getComponent: async (nextState) => {
        const { default: Security } = await import(/* webpackChunkName: "security" */ './routes/security/components/Security')
          .catch(handleChunkLoadError);

        return Security;
      }
    },
    {
      path: 'billing',
      getData: ({ context: { props } }) => props,
      getComponent: async (nextState) => {
        const { default: Billing } = await import(/* webpackChunkName: "billing" */ './routes/billing/components/Billing')
          .catch(handleChunkLoadError);

        return Billing;
      }
    },
    {
      path: 'security',
      getData: ({ context: { props } }) => props,
      getComponent: async (nextState) => {
        const { default: Security } = await import(/* webpackChunkName: "security" */ './routes/security/components/Security')
          .catch(handleChunkLoadError);

        return Security;
      }
    },
    {
      path: 'api-keys',
      getData: ({ context: { props } }) => props,
      getComponent: async (nextState) => {
        const { default: ApiKeys } = await import(/* webpackChunkName: "ApiKeys" */ './routes/api-keys/components/ApiKeys')
          .catch(handleChunkLoadError);

        return ApiKeys;
      }
    },
    {
      path: 'subscription',
      getData: ({ context: { props } }) => props,
      getComponent: async (nextState) => {
        const { default: Subscription } = await import(/* webpackChunkName: "subscription" */ './routes/subscription/components/Subscription')
          .catch(handleChunkLoadError);

        return Subscription;
      }
    },
    {
      path: 'subusers',
      async getComponent () {
        const {
          default: UserManagementPage
        } = await import('./routes/subusers/components/UserManagementPage')
          .catch(handleChunkLoadError);
        return UserManagementPage;
      },
      getData: ({
        context: {
          props
        }
      }) => props || {}
    }
  ]
});

export const CancelPlanRoutes = ({
  path: 'user',
  getData: ({ context: { props } }) => ({ ...props, hideTabs: true, isCancelFlow: true }),
  async getComponent () {
    const {
      default: AccountContainer
    } = await import('./containers/AccountContainer.tsx')
      .catch(handleChunkLoadError);
    return AccountContainer;
  },
  children: [
    {
      path: 'cancelflow',
      async getComponent (nextState) {
        const {
          default: CancelSubscriptionPage
        } = await import('./routes/cancel/components/CancelSubscriptionPage')
          .catch(handleChunkLoadError);
        return CancelSubscriptionPage;
      },
      getData: ({ context: { props } }) => (props)
    },
    {
      path: 'cancelsuccess',
      async getComponent (nextState) {
        const {
          default: CancelSubscriptionSuccessPage
        } = await import('./routes/cancel/components/CancelSubscriptionSuccessPage')
          .catch(handleChunkLoadError);
        return CancelSubscriptionSuccessPage;
      },
      getData: ({ context: { props } }) => (props)
    },
    {
      path: 'reactivatesuccess',
      async getComponent (nextState) {
        const {
          default: CancelSubscriptionSuccessPage
        } = await import('./routes/reactivate/ReactivateSubscriptionPage')
          .catch(handleChunkLoadError);
        return CancelSubscriptionSuccessPage;
      },
      getData: ({ context: { props } }) => (props)
    }
  ]
});

export const UpdateBillingAndPaymentRoutes = ({
  path: 'user',
  getData: ({ context: { props } }) => ({ ...props, hideTabs: true }),
  async getComponent () {
    const {
      default: AccountContainer
    } = await import('./containers/AccountContainer.tsx')
      .catch(handleChunkLoadError);
    return AccountContainer;
  },
  children: [
    {
      path: 'updatebilling',
      async getComponent (nextState) {
        const {
          default: UpdateBillingPage
        } = await import('./routes/update-billing/UpdateBillingPage')
          .catch(handleChunkLoadError);
        return UpdateBillingPage;
      },
      getData: ({ context: { props } }) => (props)
    },
    {
      path: 'updatepayment',
      async getComponent (nextState) {
        const {
          default: UpdatePaymentMethodPage
        } = await import('./routes/update-payment-method/UpdatePaymentMethodPage.tsx')
          .catch(handleChunkLoadError);
        return UpdatePaymentMethodPage;
      },
      getData: ({ context: { props } }) => (props)
    }
  ]
});
